module.exports = __webpack_public_path__ + "img/erc20-vatan.fa29abdd.png";